(() => {
  'use-strict';

  const body = document.querySelector('body');
  let isDesktop;

  function setIsDesktop() {
    if (window.innerWidth >= 1024) {
      isDesktop = true;
    } else {
      isDesktop = false;
    }
  }

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('init' in element.dataset) {
        return;
      }
      element.dataset.init = true;

      function clickOutsideHandle(trigger, event) {
        let targetEl = event.target; // clicked element
        do {
          if (targetEl === element.closest('nav')) {
            // This is a click inside, does nothing, just return.
            return;
          }
          // Go up the DOM
          targetEl = targetEl.parentNode;
        } while (targetEl);
        // This is a click outside.
        const viewportWidth =
          window.innerWidth || document.documentElement.clientWidth;
        if (viewportWidth >= window.breakpointsDefinition['desktop']) {
          // eslint-disable-next-line no-use-before-define
          toggle(trigger, false);
        }
      }

      const toggle = (trigger, state) => {
        if (
          (trigger.target.getAttribute('aria-expanded') === 'true') !==
          state
        ) {
          // state change we do actions
          trigger.setAttribute('aria-expanded', state);
          trigger.target.classList.add('-isAnimated');
          trigger.target.setAttribute('aria-expanded', state);
          body.classList.toggle('-footerAccordionIsExpanded', state);
          const removeAnimatedClass = () => {
            trigger.target.classList.remove('-isAnimated');
            trigger.target.addEventListener(
              'animationend',
              removeAnimatedClass,
            );
          };
          trigger.target.addEventListener('animationend', removeAnimatedClass);
          if (state === false) {
            // close actions
            trigger.links.forEach((link) => {
              link.removeEventListener('blur', link.blurLink);
            });
            document.removeEventListener('click', clickOutsideHandle);
          } else {
            // open actions
            trigger.links = trigger.target.querySelectorAll('a, button');
            trigger.links.forEach((link) => {
              link.blurLink = (event) => {
                // check if the new target is in the same parent or not
                const parentMenuItem = event.target.closest('.menu-item.lvl-0');
                if (
                  event.relatedTarget !== null &&
                  parentMenuItem !==
                    event.relatedTarget.closest('.menu-item.lvl-0')
                ) {
                  const parentTrigger =
                    parentMenuItem.querySelector('.menu-link.lvl-0');
                  toggle(parentTrigger, false);
                }
              };
              link.addEventListener('blur', link.blurLink);
            });
            document.addEventListener(
              'click',
              clickOutsideHandle.bind(null, trigger),
            );
          }
        }
      };

      // set aria-controls in button
      const buttonTriggers = element.querySelectorAll(
        'button[aria-controls].lvl-0',
      );

      // be careful to removeEventListener scope
      const blurHandle = (event) => {
        if (!isDesktop) {
          const trigger = event.target;
          const parentMenuItem = event.target.closest('.menu-item.lvl-0');
          if (
            event.relatedTarget !== null &&
            parentMenuItem !== event.relatedTarget.closest('.menu-item.lvl-0')
          ) {
            const parentTrigger =
              parentMenuItem.querySelector('.menu-link.lvl-0');
            toggle(parentTrigger, false);
          }
          event.target.blurListenerAttached = false;
          trigger.removeEventListener('blur', blurHandle);
        }
      };
      const focusHandle = (event) => {
        if (!isDesktop && !event.target.blurListenerAttached) {
          event.target.blurListenerAttached = true;
          event.target.addEventListener('blur', blurHandle);
        } else if (
          isDesktop &&
          event.target.classList.contains('menu-link') &&
          event.target.classList.contains('lvl-0')
        ) {
        // Bypass the menu-link.lvl-0 for focus: focus the first child element or the previous element's last child
          if (event.target.classList.contains('focusWithin')) {
            if (event.target.closest('.SiteFooter-menu').previousElementSibling.querySelector('.SiteFooter-socials')) {
              event.target.classList.remove('focusWithin');
              event.target
                .closest('.SiteFooter-menu')
                .previousElementSibling.querySelector('.SiteFooter-socialsList li:last-child a')
                .focus();
            } else if (event.target.closest('.SiteFooter-menu').previousElementSibling.classList.contains('SiteFooter-menu')) {
              event.target.classList.remove('focusWithin');
              event.target
                .closest('.SiteFooter-menu')
                .previousElementSibling.querySelector('.menu-link.lvl-0')
                .classList.add('focusWithin');
              event.target
                .closest('.SiteFooter-menu')
                .previousElementSibling.querySelector('.menu-list.lvl-1 li:last-child .menu-link.lvl-1')
                .focus();
            }
          } else {
            event.target.classList.add('focusWithin');
            event.target.nextElementSibling
              .querySelector('.menu-list.lvl-1 li:first-child .menu-link.lvl-1')
              .focus();
          }
        }
      };
      const clickHandle = (event) => {
        event.preventDefault();
        if (!isDesktop) {
          toggleAndCloseSiblings(event.target);
          if (!event.target.blurListenerAttached) {
            event.target.blurListenerAttached = true;
            event.target.addEventListener('blur', blurHandle);
          }
        }
      };
      const toggleAndCloseSiblings = (trigger) => {
        buttonTriggers.forEach((elt) => {
          // if element is not current or current is opened
          if (
            elt !== trigger ||
            elt.target.getAttribute('aria-expanded') === 'true'
          ) {
            toggle(elt, false);
          } else {
            // if current is closed
            toggle(trigger, true);
          }
        });
      };

      buttonTriggers.forEach((trigger) => {
        trigger.target = document.getElementById(
          trigger.getAttribute('aria-controls'),
        );

        trigger.addEventListener('click', clickHandle);
        trigger.addEventListener('focus', focusHandle);
      });

      window.addEventListener(
        'resize',
        () => {
          setIsDesktop();
        },
        false,
      );
    });
  }

  Drupal.behaviors.footerAccordion = {
    attach: () => {
      const elements = document.querySelectorAll('.js-menu-accordion-footer');
      if (elements.length !== 0) {
        setIsDesktop();
        init(elements);
      }
    },
  };
})();
